<template>
  <v-btn-toggle tile color="deep-purple accent-3" group v-model="selected">
    <v-btn
      v-for="(opts, key) in options"
      :value="key"
      :key="options[key]"
      v-on:click="setFilter(key)"
    >
      {{ options[key] }}
    </v-btn>
  </v-btn-toggle>
</template>

<script>
export default {
  data() {
    return {
      selected: "",
    };
  },
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  emits: ["filter"],
  methods: {
    setFilter(key) {
      this.$emit("filter", { key, selected: this.selected });
    },
  },
};
</script>

<style></style>
